<template>
  <el-collapse v-model="expanded">
    <el-collapse-item
      v-for="v in versions"
      :key="v.id"
      :name="v.id">

      <template #title>
        <div class="rvh-summary">
          <span class="rvh-vno">v{{ v.version_no }}</span>
          <el-tag
            v-if="v.is_current"
            type="success"
            size="mini"
            effect="dark">
            <i class="fa fa-check"></i> Current
          </el-tag>
          <el-tag
            v-else
            type="info"
            size="mini">
            <i class="fa fa-history"></i> Superseded
          </el-tag>
          <span class="rvh-meta">Published {{ formatDate(v.published_at) }}</span>
          <span class="rvh-pinned">
            <i class="fa fa-thumb-tack"></i>
            {{ v.pinned_count }} {{ v.pinned_count === 1 ? 'site' : 'sites' }} pinned
          </span>
        </div>
      </template>

      <!-- XOL-503: pass THIS VERSION'S OWN band, which the payload has carried
           since XOL-500 (API c0bcf804).

           The XOL-487 D7 rule it replaces is unchanged in substance and still
           binding: `rate_versions` snapshots its own band precisely because a
           published version's band can legitimately differ from the draft's,
           so do NOT borrow the draft's — that renders an authoritative-looking
           WRONG band on immutable history. What changed is only the SOURCE:
           the band now comes from the version itself, so there is no longer
           any reason to render band-less.

           `v` is bound BY REFERENCE, not spread or picked — which is what
           makes the degradation argument hold: a version predating the API
           change simply has no band keys, so rateBand falls through to its
           [1..10] default exactly as before. Nothing downstream writes to the
           object (RateTiersCell reads rowData, and sorts tiers via
           .slice().sort()), so sharing the reference is safe. `toSharer: null` is a real value meaning "no upper
           bound" and resolves to 10 the same way. -->
      <rate-tiers-cell :row-data="v" :hide-drawer-affordance="true" />

    </el-collapse-item>
  </el-collapse>
</template>

<script>
import DateMixins from '@/mixins/DateMixins'
import RateTiersCell from './RateTiersCell'

export default {
  name: 'rate-version-history',

  mixins: [DateMixins],

  components: {
    RateTiersCell
  },

  props: {
    versions: {
      type: Array,
      default: function () { return [] }
    }
  },

  data: function () {
    return {
      expanded: []
    }
  },

  watch: {
    versions: function (newVersions) {
      this.expandCurrent(newVersions)
    }
  },

  mounted: function () {
    this.expandCurrent(this.versions)
  },

  methods: {
    expandCurrent: function (versions) {
      var current = versions.find(function (v) { return v.is_current })
      if (current) {
        this.expanded = [current.id]
      }
    }
  }
}
</script>

<style scoped>
.rvh-summary {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  width: 100%;
}

.rvh-vno {
  font-weight: 700;
  font-size: 14px;
}

.rvh-meta {
  color: #909399;
  font-size: 12px;
}

.rvh-pinned {
  color: #606266;
  font-size: 12px;
}
</style>
